import { useMemo } from 'react';
import classnames from 'classnames';
import Select from 'react-select';
import { getFlagURL } from '@/helpers/utils';
import { EXCLUDED_COUNTRIES } from './exclude';
import { Control } from '../components/control';
import { useGetCountries } from '@/query/queries/common/useGetCountries';
import { SingleValueCountry as SingleValue } from '../components/value/country';
import { OptionCountry as Option } from '../components/option/country';
import '../components/styles/default.scss';
import s from './index.module.scss';

export const CountrySelectField = ({
  label,
  value,
  error,
  className,
  onChange,
  exclude = [],
  ...props
}) => {
  const { data } = useGetCountries();

  const countriesMap = useMemo(() => {
    if (!data) return {};

    const filtered = data.filter(
      country => ![...EXCLUDED_COUNTRIES, ...exclude].includes(country.code),
    );

    const map = {};
    filtered.forEach(country => {
      map[country.code] = {
        value: country.code,
        code: country.code,
        label: country.name || 'Unknown',
        flag: getFlagURL(country.code),
      };
    });

    return map;
  }, [data]);

  const countries = useMemo(() => Object.values(countriesMap), [countriesMap]);

  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        name="country"
        classNamePrefix="scr_select"
        className={classnames(s.country_select, error && s.country_select_error)}
        options={countries}
        components={{ Control, Option, SingleValue }}
        placeholder=""
        isSearchable
        aria-errormessage={error}
        aria-label={label}
        {...props}
      />
      {error && <div className={s.error_message}>{error}</div>}
    </div>
  );
};
